"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hook = exports.target = exports.isBrowser = void 0;
exports.isBrowser = typeof navigator !== 'undefined';
exports.target = exports.isBrowser
    ? window
    : typeof global !== 'undefined'
        ? global
        : {};
exports.hook = exports.target.__VUE_DEVTOOLS_GLOBAL_HOOK__;
//# sourceMappingURL=env.js.map